import { render, staticRenderFns } from "./CrearPersona.vue?vue&type=template&id=2a2ef85a"
import script from "./CrearPersona.vue?vue&type=script&lang=js"
export * from "./CrearPersona.vue?vue&type=script&lang=js"
import style0 from "./CrearPersona.vue?vue&type=style&index=0&id=2a2ef85a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports